var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"type":_vm.type,"size":_vm.size,"disabled":_vm.disabled,"loading":_vm.loading,"icon":"ios-download-outline"},on:{"click":_vm.action}},[[_vm._v(_vm._s(_vm.name))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }